import { Link } from "react-router-dom";
import LogoFooter from "../../assets/icon/LogoFooter";
import FooterLinks from "./components/FooterLinks";
import moment from "moment";

const Footer = () => {
  const createDate = moment(new Date()).format("YYYY");

  return (
    <>
      <div className="border-b border-light_gray pb-[4rem] mr-5 pd:pb-0"></div>
      <div className="flex justify-center items-center bg-white md:max-h-[18rem] pb-5">
        <div className="w-full max-w-xl md:max-w-[1000px] flex flex-col justify-center px-5 md:px-0">
          <div className="w-full flex flex-col justify-start items-start md:flex md:flex-row pt-[4rem]">
            {/* Footer Links section */}
            <div className="min-w-[21.5rem] flex flex-col items-start pb-7 md:flex md:flex-row md:justify-end">
              <FooterLinks />
            </div>

            {/* Links section */}
            <div className="flex flex-col justify-start items-start text-sm font-semibold md:min-w-[21.5rem]">
              <Link className="pb-3 hover:text-orange" to="/contacts">
                Контакти
              </Link>
              <Link
                className="pb-3 hover:text-orange"
                to="https://silpo.ua/polityka-konfidencijnosti"
                target="_blank"
              >
                Політика конфіденційності
              </Link>
              <Link
                className="pb-3 hover:text-orange"
                to="https://silpo.ua/pravyla-bezpeky"
                target="_blank"
              >
                Правила безпеки
              </Link>
            </div>

            {/* Logo Footer section */}
            <div className="w-full flex-col justify-start items-center pt-7 md:pt-0">
              <div className="flex items-center md:w-full">
                <LogoFooter />
              </div>
              <div>
                <p className="w-full pt-5 text-left text-[13px] opacity-60">
                  © SILPO, {createDate}
                  <span className="pl-3">v 1.141128</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
